// Reactive-ish global state. No framework: components read from this object and call
// `notify()` after mutating. Keep it small.

export const state = {
  // Lifecycle
  view: 'boot',                 // boot | enroll | keypad | confirm | feedback | blocked
  message: null,
  pwaVersion: null,

  // Device session (loaded from storage on boot)
  deviceToken: null,
  deviceMeta: null,             // { deviceId, companyId, companyName, deviceName }

  // Telemetry
  gpsGranted: null,             // null = not yet asked, true/false otherwise
  gpsDenied: false,
  lastGps: null,                // { lat, lng } or null
  serverOffsetMs: 0,            // (server - device) ms; >60s shows warning
  serverTimeWarning: false,
  online: navigator.onLine,
  pendingQueueCount: 0,
  lastHeartbeatAt: null,

  // PWA install
  installPrompt: null,          // deferred BeforeInstallPromptEvent, or null
  isInstalled: window.matchMedia('(display-mode: standalone)').matches ||
               window.matchMedia('(display-mode: fullscreen)').matches ||
               !!window.navigator.standalone,

  // Marking flow
  inputDigits: '',              // identification being typed
  candidate: null,              // { id, identification, fullName }
  feedback: null,               // { kind: 'success'|'error', text }

  // Subscribers
  _listeners: new Set()
};

export function subscribe(fn) {
  state._listeners.add(fn);
  return () => state._listeners.delete(fn);
}

export function notify() {
  state._listeners.forEach((fn) => {
    try { fn(state); } catch (e) { console.error('listener error', e); }
  });
}

window.addEventListener('online', () => { state.online = true; notify(); });
window.addEventListener('offline', () => { state.online = false; notify(); });
